import React from 'react';

import {Dropdown, Menu, MenuButton, MenuItem,} from "@mui/joy";

// icons
import ReplyIcon from '@mui/icons-material/Reply';
import ForwardIcon from '@mui/icons-material/Forward';
import DeleteIcon from "@mui/icons-material/Delete";


class MessageActions extends React.Component {
    render() {
        return(
            <Dropdown>
                <MenuButton
                    variant="plain"
                    size="sm"
                >
                    ...
                </MenuButton>
                <Menu
                    variant="plain"
                    size="sm"
                >
                    {
                        this.props.replyCallBack?
                            <MenuItem
                                onClick={() => {
                                    this.props.replyCallBack(this.props.message)
                                }}
                            >
                                Ответить
                                <ReplyIcon />
                            </MenuItem>:
                            null
                    }
                    {
                        this.props.isMyMessage && this.props.deleteCallBack?
                            <MenuItem
                                onClick={() => {
                                    this.props.deleteCallBack()
                                }}
                                color={'danger'}
                            >
                                Удалить
                                <DeleteIcon />
                            </MenuItem>:
                        null
                    }
                    <MenuItem
                        onClick={() => {
                            this.props.forwardCallBack()
                        }}
                        color={'warning'}
                    >
                        Переслать
                        <ForwardIcon />
                    </MenuItem>
                </Menu>
            </Dropdown>
        )
    }
}

export default MessageActions
